// extracted by mini-css-extract-plugin
export var ___gatsby = "template-module--___gatsby--e024e";
export var apiContainer = "template-module--apiContainer--3ba52";
export var container = "template-module--container--41847";
export var date = "template-module--date--8ad85";
export var heading = "template-module--heading--a19f2";
export var logo = "template-module--logo--f8ca1";
export var logoWrapper = "template-module--logoWrapper--26955";
export var margin50 = "template-module--margin50--4bab7";
export var wrapper = "template-module--wrapper--39b78";